import { render } from "./CourseVideo.vue?vue&type=template&id=adef8872&scoped=true"
import script from "./CourseVideo.vue?vue&type=script&lang=js"
export * from "./CourseVideo.vue?vue&type=script&lang=js"

import "./CourseVideo.vue?vue&type=style&index=0&id=adef8872&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adef8872"]])

export default __exports__